"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _TableHeaderCell = require("../TableHeaderCell/TableHeaderCell.context");
var _TableHeader = require("./TableHeader.styles");
/**
 * A native [`<thead>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/thead) element.
 *
 * @since 8.0.0
 */
var TableHeader = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_TableHeaderCell.TableHeaderCellProvider, {
    value: {
      parent: 'header'
    }
  }, /*#__PURE__*/_react.default.createElement(_TableHeader.StyledTableHeader, (0, _extends2.default)({
    ref: forwardedRef
  }, props)));
});
exports.TableHeader = TableHeader;
TableHeader.displayName = 'Table.Header';
TableHeader.propTypes = {
  /**
   * Background style of the table header.
   */
  appearance: _propTypes.default.oneOf(['light', 'dark'])
};
TableHeader.defaultProps = {
  appearance: 'light'
};